import { createAction } from '@reduxjs/toolkit';

export const fetchUserAccountsSuccess = createAction('[Account] fetchUserAccountsSuccess');
export const selectUserAccount = createAction('[Account] selectUserAccount');
